import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Modal } from "antd"

import * as Template from "../../templates";
import * as actions from "../../actions";
import { useLocation } from "react-router-dom";

export default () => {

  const moduleName = "product_prices";
  const dispatch = useDispatch();
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const location = useLocation()
  const [totalPages, setTotalPages] = useState(0)

  const [category_id, setCategoryId] = useState("")
  const [placeholder, setPlaceholder] = useState("")
  const [state, setState] = useState(0)
  const [submitted, setSubmitted] = useState(false)
  const [activeRow, setActiveRow] = useState(null)
  const [selectedThumbnail, setSelectedThumbnail] = useState(0)

  const [rows, setRows] = useState([])

  const [lgShow, setLgShow] = useState(false);

  useEffect(() => {
    dispatch(actions.list(moduleName, location.search));
  }, [location.search]);

  const handleUpdateRow = id => {
    setSubmitted(true)
    dispatch(actions.update(id + `?bulk=1`, moduleName));
  }
  const handleChangeState = value => setState(value)
  const changeModal = (status, invoiceId) => {
    setLgShow(status);
    setActiveRow(undefined)
  };

  const handleSuggest = (result) => {
    appReducer.product_categories_search_list = undefined
    setCategoryId(result.id)
    setPlaceholder(result.text)
  }

  const handleSearch = param => dispatch(actions.list("product_categories/search", "?name=" + param))
  const handleReset = () => {
    document.getElementById("searchSuggest").value = "";
    setPlaceholder("")
    setCategoryId("")
  }

  useEffect(() => {

    setRows([])

    if (submitted) {
      if (appReducer.product_prices_update != undefined) {
        dispatch(actions.list(moduleName, location.search));
        setSubmitted(false)
        window.location.reload()
      }
    }

    if (appReducer.product_prices_list != undefined) {
      setRows(appReducer.product_prices_list.data)
      setTotalPages(appReducer.product_prices_list.count)
      setLgShow(false)
    }

  }, [appReducer])

  const handleEditRow = (item) => {
    setSelectedThumbnail(item.image_id)
    setActiveRow(item)
    setLgShow(true)
  }

  const columns = [
    {
      name: 'تصویر',
      selector: row => <img className="w-16 my-5" src={row.url_full ? row.url_full : row.product.active_image} />,
    },
    {
      name: 'نام',
      selector: row => `${row.product.name} ${' | ' + row.name}`
    },
    {
      name: 'کد تنوع کالا',
      selector: row => row.code
    },
    {
      name: 'بارکد',
      selector: row => row.barcode
    },
    {
      name: 'گروه',
      selector: row => row.product.category ? row.product.category.name : "-"
    },
    {
      name: 'قیمت',
      selector: row => row.price
    },
    {
      name: "بازه ارسال روز",
      selector: row => row.max_delivery_day
    },
    {
      name: "حداکثر در سبد",
      selector: row => row.max_cart_count
    },
    {
      name: "موجودی فروشنده",
      selector: row => row.available_count
    },
    {
      name: 'تاریخ ایجاد',
      selector: row => row.created_at,
    },
    {
      name: 'عملیات',
      selector: row => <Template.Button
        label="ویرایش"
        onClick={() => handleEditRow(row)}
        background="bg-gradient-to-tr from-indigo-300 to-indigo-400  text-xs"
      />,
    }

  ];

  return <div>

    <Modal
      title="بروزرسانی تنوع محصول"
      width={1000}
      open={lgShow}
      footer={[<div></div>]}
      centered
      onCancel={() => changeModal(false, 0)}
    >
      {activeRow && <Template.Form>

        {activeRow.product.images.map((image, i) => <img className={`${selectedThumbnail == image.id ? " border-4 border-green-400" : ""} w-24`} key={i} onClick={() => setSelectedThumbnail(image.id)} src={`${image.url_medium_full}`} />)}

        <Template.Input type="hidden" className="ltr" name={`product_price[${activeRow.id}][image_id]`} value={selectedThumbnail} />

        <Template.Input label="نام" className="ltr" name={`product_price[${activeRow.id}][name]`} value={activeRow.name} />

        <Template.Input label="کد تنوع کالا" className="ltr" name={`product_price[${activeRow.id}][code]`} value={activeRow.code} />

        <Template.Input label="بارکد" className="ltr" name={`product_price[${activeRow.id}][barcode]`} value={activeRow.barcode} />

        <Template.Input label="قیمت" className="ltr" name={`product_price[${activeRow.id}][price]`} value={activeRow.price} />

        <Template.Input label="بازه ارسال روز" className="ltr" name={`product_price[${activeRow.id}][max_delivery_day]`} value={activeRow.max_delivery_day} />

        <Template.Input label="موجودی فروشنده" className="ltr" name={`product_price[${activeRow.id}][available_count]`} value={activeRow.available_count} />

        <Template.Input label="حداکثر در سبد" className="ltr" name={`product_price[${activeRow.id}][max_cart_count]`} value={activeRow.max_cart_count} />

        <input type="hidden" name="state" defaultValue={"active"} />

        <Template.Button
          label="اعمال"
          onClick={() => handleUpdateRow(activeRow.id)}
          className="p-1"
        />

      </Template.Form>}

    </Modal>

    <Template.Filter moduleName={moduleName}>
      <Template.Input
        label="بارکد محصول"
        placeholder="بارکد محصول"
        name="barcode"
        type="text"
      />
      <Template.Input
        label="کد محصول"
        className="ltr"
        placeholder="کد محصول"
        name="code"
        type="text"
      />
      <Template.Input
        label="نام محصول"
        placeholder="نام محصول"
        name="name"
        type="text"
      />
      <Template.Input
        label="کد تنوع"
        placeholder="کد تنوع"
        name="price_code"
        className="ltr"
        type="text"
      />
      <Template.SingleSelect
        onChange={handleChangeState}
        withLabel={true}
        placeholder="انتخاب وضعیت"
        name="state"
        value={state}
        options={[
          {
            value: "active",
            label: "فعال",
          },
          {
            value: "deactive",
            label: "غیرفعال",
          },
        ]}
      />
    </Template.Filter>

    <Template.Table count={totalPages} columns={columns} data={rows} />
  </div>


};
